import React from "react";

export default function PageTitle({title, subtitle, icon}) {
    return (
        <div className="page-title">
            <h1 className="title">{icon} {title}</h1>
            <span className="subtitle">{subtitle}</span>
        </div>
    )
}